/* ==========================================================================
   Ticker pause control - A11Y-05 (#112)
   WCAG 2.2.2 Pause, Stop, Hide. The strip in sections/ticker.liquid scrolls
   for as long as the page is open, and hover was the only thing that stopped
   it. This reveals the control the section renders hidden, freezes every
   ticker on the page when it is pressed, names the next action on the button
   (the WAI-ARIA carousel rotation control), and keeps the choice for the rest
   of the visit in sessionStorage - set only by the visitor, strictly
   necessary. Visitors who ask for reduced motion get a still strip from
   section-ticker.css and no control. Classic script, deferred by the section;
   a page with two ticker sections loads it twice, so it binds once.
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'woopf-ticker-paused';
  var root = document.documentElement;
  if (root.hasAttribute('data-ticker-toggle-bound')) return;
  root.setAttribute('data-ticker-toggle-bound', '');

  function reducedMotion() {
    return typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function readPaused() {
    try {
      return window.sessionStorage.getItem(KEY) === '1';
    } catch (err) {
      return false;
    }
  }

  function writePaused(paused) {
    try {
      if (paused) window.sessionStorage.setItem(KEY, '1');
      else window.sessionStorage.removeItem(KEY);
    } catch (err) {
      /* storage blocked: the pause still holds on this page */
    }
  }

  function show(button, paused) {
    var section = button.closest('.ticker-section');
    var label = button.querySelector('[data-ticker-toggle-label]');
    if (section) section.classList.toggle('is-paused', paused);
    if (label) {
      label.textContent = button.getAttribute(paused ? 'data-label-play' : 'data-label-pause');
    }
  }

  function sync(paused) {
    var buttons = document.querySelectorAll('[data-ticker-toggle]');
    var reveal = !reducedMotion();
    for (var i = 0; i < buttons.length; i += 1) {
      if (reveal) buttons[i].hidden = false;
      show(buttons[i], paused);
    }
  }

  function init() {
    sync(readPaused());
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var button = target && target.closest ? target.closest('[data-ticker-toggle]') : null;
    if (!button) return;
    var section = button.closest('.ticker-section');
    var paused = !(section && section.classList.contains('is-paused'));
    writePaused(paused);
    sync(paused);
  });

  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
